import {createTheme} from "@mui/material/styles"
import {
  ERROR_RED,
  GREY_BG,
  LOGO_BLUE,
  LOGO_BLUE_DARK,
  NAVY,
  SUCCESS_GREEN,
  WHITE
} from "./tokens"

// Central MUI theme for the Benefits2 app. Introduced by the Screen Fixes
// foundation so global colour/button rules propagate from one place instead of
// per-component inline styles. Component-level cleanup (removing the inline
// #6A75B9 / #FF9100 overrides) happens in the global-fixes branch; those inline
// styles still win until then, so this change is additive.
export const theme = createTheme({
  palette: {
    primary: {
      main: LOGO_BLUE,
      dark: LOGO_BLUE_DARK,
      contrastText: WHITE
    },
    secondary: {
      main: NAVY,
      contrastText: WHITE
    },
    error: {
      main: ERROR_RED
    },
    success: {
      main: SUCCESS_GREEN
    },
    text: {
      // G1: body text, labels, questions default to Navy on light backgrounds.
      primary: NAVY
    },
    background: {
      default: WHITE,
      paper: WHITE
    }
  },
  typography: {
    // Match the Tailwind sans stack so MUI and Tailwind text render the same.
    fontFamily: [
      "Inter var",
      "Roboto",
      "Helvetica Neue",
      "Arial",
      "sans-serif"
    ].join(",")
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        // G17: no all-caps. Rounded pill buttons app-wide.
        root: {
          textTransform: "none",
          borderRadius: 20,
          fontWeight: 700
        },
        // G2/G3: primary and secondary buttons get a 48px min touch target.
        contained: {
          minHeight: 48
        },
        outlined: {
          minHeight: 48
        }
      }
    }
  }
})

// Page background behind the white card (used by carded layouts).
export const PAGE_BACKGROUND = GREY_BG

export default theme
